import SiteMapping from '@configs/siteMapping';

const Nova88Pagination = (() => {
    return (
        <>
            <div className="
            promotions__swiper-pagination
            swiper-pagination-clickable
            swiper-pagination-bullets"
            >
                <span
                    className="swiper-pagination-bullet"
                    tabIndex="0"
                    role="button"
                    aria-label="Go to slide 1"
                />
                <span
                    className="swiper-pagination-bullet swiper-pagination-bullet-active"
                    tabIndex="0"
                    role="button"
                    aria-label="Go to slide 2"
                />
                <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 3" />
            </div>
            <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
        </>
    );
});

const Viva88Pagination = (() => {
    return (
        <>
            <div className="
                swiper-pagination
                swiper-pagination-clickable
                swiper-pagination-bullets
                swiper-pagination-horizontal"
            >
                <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 1" />
                <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 2" />
                <span
                    className="swiper-pagination-bullet swiper-pagination-bullet-active"
                    tabIndex="0"
                    role="button"
                    aria-label="Go to slide 3"
                    aria-current="true"
                />
            </div>
        </>
    );
});
const PaginationBullet = ({ siteName }) => {
    return (
        {
            [SiteMapping.Nova88]: <Nova88Pagination />,
            [SiteMapping.PICA88]: <Nova88Pagination />,
            [SiteMapping.IBCBet]: <Nova88Pagination />,
            [SiteMapping.id8899]: <Nova88Pagination />,
            [SiteMapping.viva88]: <Viva88Pagination />,
            [SiteMapping.bong88]: <Viva88Pagination />,
            [SiteMapping.bettha88]: <Nova88Pagination />,
            [SiteMapping.taraPlays]: <Nova88Pagination />,
            [SiteMapping.fifabet]: <Nova88Pagination />,
            [SiteMapping.ocean99]: <Nova88Pagination />,
        }[siteName]
    );
};

export default PaginationBullet;
